import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { apiCall } from 'helpers/apiHelper';
import moment from 'moment';
import { adminRoot,dashboardPath,defaultAvatar,defaultOrgLogo} from 'constants/defaultValues';
import { setCurrentUser,getCurrentUser } from 'helpers/Utils';
import {
  LOGIN_USER,
  LOGOUT_USER,
} from '../contants';

import {
  loginUserSuccess,
  loginUserError,
} from './actions';

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const loginWithEmailPasswordAsync = async (email, password) =>
  // eslint-disable-next-line no-return-await
  await apiCall({ username: email, password }, 'post', 'token-auth/')
    .then((user) => user)
    .catch((error) => error);

function* loginWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const user = getCurrentUser();
    if(!user){
      const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
      if (loginUser.token) {
        const item = {
          uid: loginUser.user.id,
          token:loginUser.token,
          old_uid:null,
          old_token:null,
          switch_back:false,
          is_locked:loginUser.is_locked,
          allow_access:loginUser.allow_access,
          two_fa_status:loginUser.user.two_fa_status,
          logged_in_time:(new Date(loginUser.logged_in_time)),
          user_full_name: `${loginUser.user.name? loginUser.user.name: `Demo 2020`}`,
          img: '/assets/img/profiles/l-1.jpg',
          date: 'Last seen today 15:24',
          role:loginUser.role,
          organisation_id:loginUser.organisation && loginUser.organisation.id,
          organisation_name:loginUser.organisation && loginUser.organisation.name,
          logo_url:loginUser.organisation.logo_url?loginUser.organisation.logo_url:defaultOrgLogo,
          organisation_short_name:loginUser.organisation && loginUser.organisation.short_name,
          branch_id:loginUser.branch && loginUser.branch.id,
          branch_name:loginUser.branch && loginUser.branch.name,
          branch_short_name:loginUser.branch && loginUser.branch.short_name,
          organisation_settings:loginUser.organisation_settings,
          permissions:loginUser.permissions,
          profile_url:loginUser.profile_url? loginUser.profile_url:defaultAvatar,
          city: loginUser.organisation && loginUser.organisation.city,
          address:loginUser.organisation && loginUser.organisation.address,
          phone_number:loginUser.organisation && loginUser.organisation.phone_number,
          branch_address:loginUser.branch && loginUser.branch.address,
          username:loginUser.user.username,
          assigned_days:loginUser.user.assigned_days,
          pass_expiry_status:loginUser.user.pass_expiry_status, 

        }
        setCurrentUser(item);
        localStorage.setItem('nextLockTime',moment().format('YYYY-MM-DD HH:mm')); 
        localStorage.setItem('nextActivityTime',moment().format('YYYY-MM-DD HH:mm'));
        yield put(loginUserSuccess(item));
        history.push(dashboardPath);
      } else {
        yield put(loginUserError('Wrong usernane or Password'));
      }
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

export function* watchLogoutUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  history.push(adminRoot);
};

function* logout({ payload }) {
  const { history } = payload;
  setCurrentUser();
  yield call(logoutAsync, history);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser)
  ]);
  // fork(watchForgotPassword),
  // fork(watchResetPassword),
}
